var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('framed-table',{attrs:{"striped":_vm.striped}},[_vm._t("default",null,{"rows":_vm.pageRows}),_vm._v(" "),(_vm.rows.length)?_c('table-pager',{attrs:{"slot":"footer","total":_vm.rows.length,"page":_vm.page,"page-size":_vm.pageSize},on:{"update:page":function($event){_vm.page=$event},"update:pageSize":_vm.changePageSize},slot:"footer"}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4890b8a3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/default/pagedTable.vue
// module id = 892
// module chunks = 0